import { useEffect } from 'react';
import { useParams } from 'react-router';
import CiudadForm from '../../components/ciudades/CiudadForm';
import { useCiudadesStore, type ActualizarCiudad } from '../../stores/ciudades/ciudades.store';

const EditarCiudad = () => {
  const paramId = useParams<{ id: string }>().id ?? '';
  const id = Number(paramId);
  const {
    current: ciudad,
    actualizar,
    cargarPorId,
    desactivar,
    activar
  } = useCiudadesStore((state) => state);

  useEffect(() => {
    if (!id) return;

    cargarPorId(id);
  }, [id]);

  const handleSave = async (values: ActualizarCiudad) => {
    await actualizar(id, values);
  };

  const handleDelete = async () => {
    await desactivar(id);
  };

  const handleActivate = async () => {
    await activar(id);
  };

  return (
    <CiudadForm
      ciudad={ciudad}
      onSave={handleSave}
      onDelete={handleDelete}
      onActivate={handleActivate}
    />
  );
};

export default EditarCiudad;
